import React, { useMemo, useCallback } from 'react';
import { connect } from 'react-redux';
import { setSortOption } from '../../../../../../actions/searchActions';
import styles from './styles.module.css';

function RadioFilterBase({
  sortOptions = [],
  sort_option,
  setSortOption,
  title = 'Ordenar por',
  ariaLabel = 'Ordenar por',
  showDivider = true,
}) {
  const options = useMemo(() => {
    if (!Array.isArray(sortOptions)) return [];
    return sortOptions.map((opt, index) => ({
      id: opt.name || `option-${index}`,
      label: opt.displayName || '',
      value: opt.name || '',
      selected: sort_option === (opt.name || opt.value),
    }));
  }, [sortOptions, sort_option]);

  const handleChange = useCallback(
    (value) => {
      if (value && value !== sort_option) {
        setSortOption(value);
      }
    },
    [sort_option, setSortOption]
  );

  if (!options.length) return null;

  return (
    <div className={styles.container}>
      {title ? (
        <div className={styles.header}>
          <span className={styles.title}>{title}</span>
        </div>
      ) : null}

      <div className={styles.radioList} role="radiogroup" aria-label={ariaLabel}>
        {options.map((opt) => (
          <label key={opt.id} className={styles.radioLabel}>
            <input
              type="radio"
              name="sort-option"
              className={styles.radioInput}
              value={opt.value}
              checked={opt.selected}
              onChange={() => handleChange(opt.value)}
              aria-label={opt.label}
            />
            <span className={styles.radioText}>{opt.label}</span>
          </label>
        ))}
      </div>

      {showDivider ? <div className={styles.divider} /> : null}
    </div>
  );
}

const mapStateToProps = (state) => ({
  sortOptions: state.search.sortOptions || [],
  sort_option: state.search.sort_option,
});

export default connect(mapStateToProps, { setSortOption })(RadioFilterBase);



// WEBPACK FOOTER //
// ./src/views/v2/search/components/filter/components/RadioFilter.jsx